var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: '_option', base: '_field', prototype: {
    container_selector: '.option',

    init: function (params) {
      xP.controls._option.base.init.apply(this, arguments);

      if (!this.root()._param(this.type)) {
        this.root()._param(this.type, {});
      }

      if (!this.root()._param(this.type)[this.name]) {
        this.root()._param(this.type)[this.name]
          = {siblings: new xP.list()};
      }

      this._.group = this.root()._param(this.type)[this.name];

      this._.group.siblings.append(this);

      this.selected = null;

      this._init_val();
    },

    append: function (params) {
      if ($.type(params) !== 'array') {
        params = [params];
      }

      var i = 0, ii = params.length, html = '', id;

      for (; i < ii; i++) {
        id = this.name + '_' + (this._.group.siblings.length + i);

        html += '<div class="option"><input type="' + this.type
        + '" name="' + this.name + '" id="' + id
        + '" value="' + (
          $.type(params[i]) === 'array'
            ? params[i][1]
            : params[i]
        ) + '"/><label for="' + id + '">' + (
          $.type(params[i]) === 'array'
            ? params[i][0]
            : params[i]
        ) + '</label></div>'
      }

      return xP($(html).insertAfter(this.$container).find('input'));
    },

    change_events: 'change',

    change: function (handler, remove) {
      this.select(this.$element.is(':checked'), true);

      xP.controls._option.base.change.apply(this, arguments);

      return this;
    },

    _init_val: function () {
//			this.select(this.$element.is(':checked'));

      if (this.selected) {
        this.$container.addClass(this.container_initial_selected_class);
      }

      xP.controls._option.base._init_val.apply(this, arguments);
    },

    container_initial_selected_class: 'initial_selected',
    container_selected_class: 'selected',

    val: function (value) {
      if (!arguments.length) {
        return !this.selected
          ? ''
          : xP.controls._option.base.val.apply(this, arguments);
      } else if ($.type(value) === 'array') {
        var i = value.length;

        while (i--) {
          if (this.$element[0].value == value[i]) {
            break;
          }
        }

        this.select(i > -1);
      } else {
        this.select(this.$element[0].value == value);
      }

      return this;
    },

    select: function (selected, _onchange) {
      selected = !arguments.length || selected;

      if (this.selected !== selected) {
        this.selected = selected;

        this.$container.toggleClass(
          this.container_selected_class,
          selected
        );

        if (selected) {
          this.$element.attr('checked', true);
          this.$element[0].checked = true; // For FF 18.
        } else {
          this.$element.removeAttr('checked');
        }

        if (!_onchange) {
          this.change();
        }
      }
      return this;
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/_option.js
 ** module id = 6
 ** module chunks = 0
 **/